import {IntermediatePart} from "../../intermediatePart";

export default class GlobalShadow extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'global_shadow';
    this.partName = 'Global Shadow';
  }

  load(dbFeature) {
    return super.load_(dbFeature, new GlobalShadow());
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.GlobalShadow;
    }
  }
}